import React, { useState } from 'react';
import { Table, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import PO_MaterialTable from './PO_MaterialTable'
import { useNavigate } from 'react-router-dom';


const data = [
  {
    key: '01',
    sno: '03',
    month: 'Mar Month',
    mspcname: 'KARWAR',
    plannedrawcalc: '1200T',
    oldfinalqty: '2.5T',
    additionalqty: '0',
    netorderqty: '1202.5T',
    status: 'Not Initiated',
  },
  {
    key: '02',
    sno: '03',
    month: 'Mar Month',
    mspcname: 'A1B2C3D',
    plannedrawcalc: '1200T',
    oldfinalqty: '2.5T',
    additionalqty: '0',
    netorderqty: '1202.5T',
    status: 'Not Initiated',
  },
  {
    key: '03',
    sno: '03',
    month: 'Mar Month',
    mspcname: 'A1B2C3D',
    plannedrawcalc: '1200T',
    oldfinalqty: '2.5T',
    additionalqty: '2T',
    netorderqty: '1202.5T',
    status: 'Completed',
  },
  
];

const PO_PageTwo = () => {
  const [searchText, setSearchText] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterStatus, setFilterStatus] = useState('All');
  const navigate=useNavigate();
  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
    columnWidth: 44,
    renderCell: (checked, record, index, originNode) => (
      <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 24 }}>
        {originNode}
      </span>
    ),
  };

  // Filtering data remains the same as previous logic
  const filteredData = data.filter((item) => {
    const matchesSearch =
      item.mspcname.toLowerCase().includes(searchText.toLowerCase());
    const matchesStatus =
      filterStatus === 'All' ? true : item.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const columns = [
    { title: 'S.No', dataIndex: 'sno', key: 'sno', align: 'center', width: 60 },
    { title: 'Month', dataIndex: 'month', key: 'month', align: 'center', width: 90 },
    { title: 'MSPC Name', dataIndex: 'mspcname', key: 'mspcname', align: 'center' },
    { title: 'Planned Raw Calc.', dataIndex: 'plannedrawcalc', key: 'plannedrawcalc', align: 'center', width: 125 },
    { title: 'Old Final QTY', dataIndex: 'oldfinalqty', key: 'oldfinalqty', align: 'center', width: 110 },
    { title: 'Additional Qty', dataIndex: 'additionalqty', key: 'additionalqty', align: 'center', width: 110 },
    { title: 'Net Order Qty', dataIndex: 'netorderqty', key: 'netorderqty', align: 'center', width: 115 },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (status) => (
        <span style={{ color: '#58595B', fontWeight: 400 }}>{status}</span>
      )
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      render: (_, record) =>
        record.status === 'Completed'
          ? <a href="#" style={{ fontWeight: 500, textDecoration: 'underline' }}  onClick={()=>navigate("/master/purchase/po-materialtable")}>View or edit</a>
          : <a href="#" style={{  fontWeight: 500 }}>Edit</a>,
    },
  ];

  return (
    <div style={{
      padding: '32px 28px 20px',
      background: '#F5F7FB',
      borderRadius: '12px',
      maxWidth: 940,
      margin: '0 auto',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: 18,
        gap: 12,
      }}>
        <Input
          placeholder="Search by MSPC or FCI"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          style={{
            width: "50%",
            borderRadius:"15px",
            fontSize: 15,
            height: 38,
            background: '#fff',
          }}
        />
        <Button
          type="default"
          style={{
            borderRadius: 18,
            fontSize: 14,
            // border: filterStatus === 'All' ? '2px solid #d9d9d9',
            // color: filterStatus === 'All' ? '2px solid #d9d9d9',
            background: "#fff",
            padding: "0 18px",
            height: 35,
            marginLeft:75
          }}
          onClick={() => setFilterStatus('All')}
        >
          All
        </Button>
        <Button
          type="default"
          style={{
            borderRadius: 18,
            fontSize: 14,
            // border: filterStatus === 'Completed' ? '2px solid #04128F' : '2px solid #d9d9d9',
            // color: filterStatus === 'Completed' ? '#04128F' : '#595959',
            background: "#fff",
            padding: "0 18px",
            height: 35,
          }}
          onClick={() => setFilterStatus('Completed')}
        >
          Completed
        </Button>
      </div>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={filteredData}
        size="small"
        
        pagination={false}
        rowKey="key"
        style={{
          fontSize: 15,
          background: '#fff',
          borderRadius: 8,
           border: '1px solid #d9d9d9',
        }}
        scroll={{ x: true }} 
      />
      <div style={{
        marginTop: 26,
        display: 'flex',
        justifyContent: 'center',
      }}>
        <Button
          type="primary"
         
          style={{
            borderRadius: 8,
            padding: '0 40px',
            height: 38,
            fontSize: 15,
            background: '#1451FF',
            border: 'none',
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default PO_PageTwo;